export default __webpack_public_path__ + "static/media/background-splash-top.757cb6b6.svg";